import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { toArray , map, filter, each , find } from 'lodash';
import { Location } from '@angular/common';





@Component({
  selector: 'fihe-filter-map',
  templateUrl: './filter-map.component.html',
  styleUrls: ['./filter-map.component.scss']
})
export class FilterMapComponent {


  destroyed = false;
  map;
  markers = [];
  mapCenterCoords = {lat: 50.684495, lng:7.149061};
  bounds;
  Tooltip;

  activeMarker;

  constructor(private ref: ChangeDetectorRef, private router: Router, private location: Location) {

    window['initMap2'] = () => {
      this.initMap();
    }
    window['toggleMap'] = () => this.refesh();
    window['mapUpdate'] = (e) => this.mapUpdate(e);
    if ( window['jQuery'].find('.gmap').length <= 0 ) {
      window['jQuery']('head').append('<script class="gmap" async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAX6mJR-r3dA0PDdMJkTIudlf3fdGdrnAc&callback=initMap2"></script>');
    } else {
      setTimeout(()=>{
        this.initMap();
      },100);
    }
  }

  ngOnInit(){

  }



  mapUpdate(_raw) {
    var $self = window['jQuery'](_raw);



    this.clear();
    this.addMarkers($self);
    this.refesh();

  }


  addMarkers(_node){
    this.bounds = new window['google'].maps.LatLngBounds();

    _node.find('.company-box').each(( _index, _node )=>{
        var $n = window['jQuery'](_node);

        if ( $n.data('geoLat') && $n.data('geoLat').length > 0 && $n.data('geoLon') && $n.data('geoLon').length > 0 ) {
          var latlang = {lat: $n.data('geoLat').replace(',','.')*1, lng: $n.data('geoLon').replace(',','.')*1};

          var m = new window['google'].maps.Marker({
            position: latlang,
            map: this.map,
            icon: '/typo3conf/ext/fihe_template/Resources/Public/img/marker-icon.png'
          });

          // m.addListener('mouseover', function(e) {
          //
          //   console.log('Show at: ' , arguments);
          //   console.log( this.map.getProjection() );
          //   var point = this.map.getProjection().fromLatLngToDivPixel(e.latLng);
          //   console.log(point);
          // });
          //
          // // assuming you also want to hide the infowindow when user mouses-out
          // m.addListener('mouseout', function() {
          //   console.log('hide');
          // });

          var tooltipOptions={
            marker:m,// required
            content: $n.find('.name').text() ,// required
            cssClass:'tooltip', // name of a css class to apply to tooltip
            node: $n,
            did : $n.data('dienstleisterId'),
            index: _index
          };

          var tooltip = new this.Tooltip(tooltipOptions);

          this.bounds.extend(m.getPosition());

          this.markers.push(m);

        }

    });
  }

  makeTooltipClass(){

    var that = this;

    function Tooltip(options) {

        // Now initialize all properties.
        this.marker_ = options.marker;
        this.content_ = options.content;
        this.map_ = options.marker.get('map');
        this.cssClass_ = options.cssClass || null;
        this.node_ = options.node;
        this.did = options.did;
        this.index = options.index;

        // We define a property to hold the content's
        // div. We'll actually create this div
        // upon receipt of the add() method so we'll
        // leave it null for now.
        this.div_ = null;

        //Explicitly call setMap on this overlay
        this.setMap(this.map_);
        var me = this;

        // Show tooltip on mouseover event.
        window['google'].maps.event.addListener(me.marker_, 'mouseover', function () {
            me.show();
        });

        window['google'].maps.event.addListener(me.marker_, 'click', function () {

          var _node = window['jQuery']('.company-box[data-dienstleister-id="'+ me.did +'"]');

          if (that.activeMarker && that.activeMarker.setIcon) {
            that.activeMarker.setIcon('/typo3conf/ext/fihe_template/Resources/Public/img/marker-icon.png');
          }

          window['jQuery']('.forceShow').removeClass('forceShow');
          me.marker_.setIcon('/typo3conf/ext/fihe_template/Resources/Public/img/marker-icon-active.png');
          _node.addClass('forceShow');

          that.activeMarker = me.marker_;
          me.marker_.setZIndex(window['google'].maps.Marker.MAX_ZINDEX + 1);

        });

        if ( this.index == 0 ) {
          var _node = window['jQuery']('.company-box[data-dienstleister-id="'+ me.did +'"]');

          if (that.activeMarker && that.activeMarker.setIcon) {
            that.activeMarker.setIcon('/typo3conf/ext/fihe_template/Resources/Public/img/marker-icon.png');
          }

          window['jQuery']('.forceShow').removeClass('forceShow');
          me.marker_.setIcon('/typo3conf/ext/fihe_template/Resources/Public/img/marker-icon-active.png');
          _node.addClass('forceShow');

          that.activeMarker = me.marker_;
          me.marker_.setZIndex(window['google'].maps.Marker.MAX_ZINDEX + 1);
        }

        // Hide tooltip on mouseout event.
        window['google'].maps.event.addListener(me.marker_, 'mouseout', function () {
           me.hide();
        });
    }
    Tooltip.prototype = new window['google'].maps.OverlayView();
    Tooltip.prototype.onAdd = function () {

        // Create the DIV and set some basic attributes.
        var div = document.createElement('DIV');
        div.style.position = "absolute";
        // Hide tooltip
        div.style.visibility = "hidden";
        if (this.cssClass_)
            div.className += " " + this.cssClass_;

        //Attach content to the DIV.
        div.innerHTML = this.content_;

        // Set the overlay's div_ property to this DIV
        this.div_ = div;

        // We add an overlay to a map via one of the map's panes.
        // We'll add this overlay to the floatPane pane.
        var panes = this.getPanes();
        panes.floatPane.appendChild(this.div_);

    }
    Tooltip.prototype.draw = function () {

        // Position the overlay. We use the position of the marker
        // to peg it to the correct position, just northeast of the marker.
        // We need to retrieve the projection from this overlay to do this.
        var overlayProjection = this.getProjection();

        // Retrieve the coordinates of the marker
        // in latlngs and convert them to pixels coordinates.
        // We'll use these coordinates to place the DIV.
        var ne = overlayProjection.fromLatLngToDivPixel(this.marker_.getPosition());

        // Position the DIV.
        var div = this.div_;
        div.style.left = (ne.x + 20) + 'px';
        div.style.top = (ne.y - 40) + 'px';

    }
    Tooltip.prototype.onRemove = function () {
        this.div_.parentNode.removeChild(this.div_);
    }

    // Note that the visibility property must be a string enclosed in quotes
    Tooltip.prototype.hide = function () {
        if (this.div_) {
            this.div_.style.visibility = "hidden";
        }
    }

    Tooltip.prototype.show = function () {
        if (this.div_) {
            this.div_.style.visibility = "visible";
        }
    }

    this.Tooltip = Tooltip;

  }


   initMap() {

     this.makeTooltipClass();

    this.map = new window['google'].maps.Map(document.getElementById('map2'), {
        center: this.mapCenterCoords,
        scrollwheel: false,
        streetViewControl: false,
        mapTypeId: window['google'].maps.MapTypeId.ROADMAP,
        zoom: 12,
        styles: [{"elementType": "labels.icon", "stylers": [{"visibility": "off"}]}]
    });

    this.addMarkers( window['jQuery']('body') );


    if ( window['showMap'] ) {
        window['jQuery']('.filter-map').show();
        this.refesh();
    }

  }

  clear(){
    for (var i = 0; i < this.markers.length; i++ ) {
      this.markers[i].setMap(null);
    }
    this.markers.length = 0;
  }


  // Refresh the Viewport
  refesh(){
    window['google'].maps.event.trigger(this.map, 'resize');
    this.map.fitBounds(this.bounds);
  }

  ngOnDestroy(){
    this.destroyed = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/filter-map/filter-map.component.ts